// crewbit-admin/src/components/money/settings/SettingsStatusPill.tsx
//
// Settings hub status pill primitive (NEW Session 139, distinct from
// `components/common/StatusPill.tsx` which carries invoice-status semantics).
// Mirrors crewbit-mobile/components/money/settings/SettingsStatusPill.tsx.
//
// Semantic kinds:
//   ACTIVE → green     (something is on / set / connected)
//   LEARN  → blue      (educational coming-soon affordance)
//   INVITE → amber     (call-to-action: invite / connect / link)
//   EMPTY  → neutral   (nothing here yet — calm state)

import { palette, radii, spacing } from '../../../styles/tokens';

export type SettingsStatusPillKind = 'active' | 'learn' | 'invite' | 'empty';

interface SettingsStatusPillProps {
  kind: SettingsStatusPillKind;
  label: string;
}

interface Tone {
  bg: string;
  fg: string;
}

const TONE: Record<SettingsStatusPillKind, Tone> = {
  active: { bg: palette.greenWash, fg: palette.green },
  learn: { bg: palette.accentWash, fg: palette.accent },
  invite: { bg: palette.amberWash, fg: palette.amber },
  empty: { bg: palette.g100, fg: palette.g600 },
};

export default function SettingsStatusPill({ kind, label }: SettingsStatusPillProps) {
  const tone = TONE[kind];
  return (
    <span
      style={{
        display: 'inline-block',
        backgroundColor: tone.bg,
        color: tone.fg,
        borderRadius: radii.sm,
        paddingInline: spacing.sm,
        paddingBlock: spacing.xs,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.3,
        textTransform: 'uppercase',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
